import { Schema, SchemaNodeProps } from '@typings';

import { SchemaField } from '../SchemaField';

import { SchemaAnyOf } from './SchemaAnyOf';
import { SchemaArray } from './SchemaArray';
import { SchemaContainer } from './SchemaContainer';

type Props = SchemaNodeProps & {
  schema: Schema.Model;
  isTopLevelNode?: boolean;
};

export const SchemaNode: React.FC<Props> = ({
  schema,
  isTopLevelNode,
  withFormatter,
}) => {
  switch (schema.type) {
    case Schema.Type.Container:
      return (
        <SchemaContainer
          withFormatter={withFormatter}
          schema={schema}
          isTopLevelNode={isTopLevelNode}
        />
      );

    case Schema.Type.Array:
      return <SchemaArray schema={schema} />;

    case Schema.Type.AnyOf:
      return <SchemaAnyOf schema={schema} />;

    case Schema.Type.Field: {
      return (
        <SchemaField
          withFormatter={withFormatter}
          name={schema.properties.name}
          typeName={schema.typeName}
          properties={schema.properties}
          isTopLevelNode={isTopLevelNode}
        />
      );
    }

    default:
      return null;
  }
};
